import React from "react";
import services from "../img/Hizmetler foto.jpg";
import LanguageApi from "../components/Language";
const Services = () => {
  const {services_text} = LanguageApi();
  return (
    <div className="corporate">
      <div className="corporate-img">
        <img src={services} alt="corporate" />
      </div>
      <div className="corporate-body">
        <div className="corporate-body-in" dangerouslySetInnerHTML={{__html: services_text}}>
        </div>
      </div>
    </div>
  );
};

export default Services;
